
<img *ngIf="artikelNr?.length > 0" 
     [src]="imageUrl"
     onError="this.src='https://www.mza-vertrieb.de/images/symbole/transparent.png'"
     height="60px" width="60px" />

